<template>
  <component :is="`el-${item.post}`" :item="item" :optionList="optionList" v-bind="$attrs"></component>
</template>

<script>
import ElTestGroup from "./copn/el-testGroup.vue";
import ElSendGroup from "./copn/el-sendGroup.vue";
export default {
  props: {
    item: Object,
    optionList: Array,
  },
  components: {
    ElTestGroup,
    ElSendGroup,
  },
};
</script>

<style lang="scss" scoped></style>
